import * as types from "../actions/types";



const initialState = {
  list: null,
  loading: false,
  adsById: null
};


export default function orders(state = initialState, action) {
  switch (action.type) {
    case types.SET_ORDERS_LIST:
      return {
        ...state,
        ordersList: action.payload
      };
    case types.SET_SPECS:
      return {
        ...state,
        specs: action.payload
      };
    case types.SET_SPEC_TYPES_LIST:
      return {
        ...state,
        specTypesList: action.payload
      };
    case types.SET_SPEC_FIELDS:
      return {
        ...state,
        specFields: action.payload
      };
    case types.SET_SPECS_VALUES:
      return {
        ...state,
        specValues: action.payload
      };
    case types.SET_ORDERS_LOADING:
      return {
        ...state,
        loading: action.payload
      };

    default:
      return state;
  }
}